import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className"];
import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
var MarkdownRenderer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  if (!children) {
    return null;
  }

  return /*#__PURE__*/_jsx("div", _extends({}, rest, {
    ref: ref,
    className: classNames(className, 'rcv-markdown'),
    dangerouslySetInnerHTML: {
      __html: children
    }
  }));
});
export default MarkdownRenderer;